<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3"></b-spinner>
      <strong>Loading...</strong>
    </div>

    <div v-show="!isLoading">
      <div v-if="!isImportFailed" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">Berhasil unggah</h5>
          <p>Kembali ke Tabel Multi IMEI untuk melihat hasil unggahan</p>
        </div>
      </div>

      <b-tabs v-else v-model="activeTab" lazy>
        <b-tab title="Multi IMEI" class="card p-4">
          <Table :fields="resultFields" :listGetter="fetchData" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/import/upload-success.png'
import { resultFields } from '../lib/uploadResultFields'
import Table from '../components/Table'

export default {
  components: {
    Table,
  },
  data() {
    return {
      activeTab: 0,
      resultFields,
      isLoading: false,
      isImportFailed: true,
    }
  },
  computed: {
    uploadSuccessImg() {
      return uploadSuccessImg
    },
    fields() {
      return []
    },
  },
  methods: {
    async fetchData() {
      const data = this.$route.params.file
      if (!data) return
      this.isImportFailed = data.status === 500
      this.isLoading = false
      if (
        data.status === 500 &&
        (data.data.message === 'Import Format is Incorrect' ||
          Object.keys(data.data).includes('Row %v1'))
      ) {
        this.$toast.error('Unggah gagal. Format import tidak sesuai')
        this.$router.push({
          name: 'Multi IMEI Import',
        })
      } else if (data.status === 500 && data.data.message === 'Internal Server Error') {
        this.$toast.error('Gagal Unggah Data')
        this.$router.push({
          name: 'Multi IMEI Import',
        })
      }
      return Object.values(data.data ?? data)
    },
  },
}
</script>
<style lang="scss" scoped>
.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
